import React from 'react';
import { useNavigate } from 'react-router-dom';
import DiningHallHotspot from '../components/hotspots/DiningHallHotspot';
import KitchenHotspot from '../components/hotspots/KitchenHotspot';
import FoodCourtHotspot from '../components/hotspots/FoodCourtHotspot';

function CampusDining() {
  const navigate = useNavigate();

  return (
    <div className="page splash campusDiningPage">
      <div className="page-header">Campus Dining</div>

      <div className="text-blocks">
        <div className="std-text">
          Use InfoGenesis Meal Plan Integration to offer your students the convenience of cashless tender.

          Establish multiple types of Meal Plan accounts for students and faculty through student cards, payroll deductions, stored value and VIP cards.
        </div>
      </div>

      <div className="logo" onClick={() => navigate('/aboutus')}>
        <img src="/assets/higher-ed/agilysys-wordmark.svg" alt="Agilysys" style={{width:'100%',height:'auto'}} />
      </div>

      <div className="campus-dining-map">
        <div className="dining-hall">
          <DiningHallHotspot onClick={() => navigate('/campus-dining/dining-hall')} />
        </div>
        <div className="kitchen">
          <KitchenHotspot onClick={() => navigate('/campus-dining/kitchen')} />
        </div>
        <div className="food-court">
          <FoodCourtHotspot onClick={() => navigate('/campus-dining/food-court')} />
        </div>
      </div>

      <div className="tap">
        <img src="/assets/higher-ed/solutions/Blue-Touch-Icon.gif" alt="" />
        <div className="tap-prompt">
          Tap on each section of the map{'\n'}To drill into the details
        </div>
      </div>
    </div>
  );
}

export default CampusDining;
